module.exports = {"620121100":"城关镇","620121101":"红城镇","620121102":"中堡镇","620121103":"武胜驿镇","620121104":"河桥镇","620121105":"连城镇","620121106":"苦水镇","620121109":"大同镇","620121110":"龙泉寺镇","620121111":"树屏镇","620121112":"上川镇","620121113":"柳树镇","620121114":"通远镇","620121201":"坪城乡","620121202":"民乐乡","620121204":"七山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620121.json
// module id = 2895
// module chunks = 0